// SPDX-License-Identifier: MIT
import { Point as _Point } from './point';
import { PublicKey as _PublicKey } from './public-key';
import { PrivateKey as _PrivateKey } from './private-key';
export class EllipticCurveCryptography {
    static NAME;
    static ORDER;
    static GENERATOR;
    static POINT;
    static PUBLIC_KEY;
    static PRIVATE_KEY;
}
export { _Point as Point, _PublicKey as PublicKey, _PrivateKey as PrivateKey, };
//# sourceMappingURL=ecc.js.map